import { EventProduct, MetricsEvent } from "./metrics";

const metrikaId = 95583657;

export const sendToYandexMetrica = (event: MetricsEvent) => {
  if (typeof window === "undefined") return;
  if (typeof (window as any).ym !== "function") return;

  const sendEvent = (goal: string, payload?: Record<string, any>) => {
    (window as any).ym(metrikaId, "reachGoal", goal, payload);
  };
  const hit = (url: string, payload?: Record<string, any>) => {
    (window as any).ym(metrikaId, "hit", url, payload);
  };
  
  switch (event.type) {
    case "session_start": {
      const payload = event.data;

      sendEvent("Session Start", {
        UserId: payload.userId,
      });
      break;
    }

    case "page_view": {
      const payload = event.data;
      hit(payload.url);
      break;
    }
    
    case "view_item": {
      const payload = event.data;

      sendEvent("Product View", {
        product_id: payload.product.id,
        name: payload.product.name,
        category: payload.product.category,
      });
      break;
    }
    
    case "add_to_cart": {
      const payload = event.data;

      sendEvent("Add to Cart", {
        products: transformProducts([payload.product]),
      });
      break;
    }

    case "remove_from_cart": {
      const payload = event.data;

      sendEvent("remove_from_cart", {
        products: transformProducts([payload.product]),
      });
      break;
    }

    case "add_to_favorites": {
      const payload = event.data;

      sendEvent("add_to_favorites", {
        products: transformProducts([payload.product]),
      });
      break;
    }

    case "remove_from_favorites": {
      const payload = event.data;

      sendEvent("remove_from_favorites", {
        products: transformProducts([payload.product]),
      });
      break;
    }

    case "order_status_check": {
      sendEvent("order_status_check");
      break;
    }
      
    case "begin_checkout": {
      const payload = event.data;

      sendEvent("Checkout", {
        sessionId: payload.userId ?? null,
        products: transformProducts(payload.products),
        total: payload.total,
      });
      break;
    }
      
    case "purchase": {
      const payload = event.data;

      sendEvent("Purchase", {
        order_id: payload.orderId,
        products: payload?.products ? transformProducts(payload.products) : undefined,
        total: payload?.value,
        shipping: payload?.shippingMethod,
        status: payload?.status ?? "",
      });
      break;
    }
    
    case "repeat_purchase": {
      const payload = event.data;

      sendEvent("repeat_purchase", {
        user_id: payload.userId,
      });
      break;
    }
      
    case "return_initiated": {
      const payload = event.data;

      sendEvent("return_initiated", {
        order_id: payload.orderId,
      });
      break;
    }
  }
};

const transformProducts = (products: EventProduct[]) => {
  return products.map((product) => ({
    id: product.id,
    product_id: product.id,
    name: product.name,
    category: product?.category?.name ?? "Продукт",
    brand: "Qazaq Republic",
    price: product?.price ?? 0,
    quantity: product?.quantity ?? 1,
  }));
};
